import { NgModule } from '@angular/core';

import { FroalaHeightPipe } from '@shared/pipes/form-builder/froala-height.pipe';
import { CastToNumberPipe, CastToStringPipe, ToArrayPipe } from '@shared/pipes/form-builder/input-value.pipe';

@NgModule({
  imports: [FroalaHeightPipe, ToArrayPipe, CastToNumberPipe, CastToStringPipe],
  exports: [FroalaHeightPipe, ToArrayPipe, CastToNumberPipe, CastToStringPipe],
})
export class FormBuilderPipesModule {}
